import React, { useMemo } from 'react';
import { IRegionShort, IRelatedForRegion } from 'api/region/types';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { HeroNav } from 'components/common/HeroNav';
import { IResortPathInfo } from 'api/resort/types';
import { getLocale } from 'i18n/locale';
import { ELocale } from 'i18n/localeEnum';
import {
  CurrentLink, CurrentTab, linksPlan, linksSnow,
} from './constants';

export const RegionHeaderNav = ({
  region, title, photo, link, resort, related,
}: {
  region: IRegionShort,
  title: string,
  photo: string,
  tab: CurrentTab,
  link: CurrentLink,
  related: IRelatedForRegion,
  resort: IResortPathInfo
}) => {
  const { t } = useOTSTranslation('common');
  const locale = getLocale() as ELocale;

  const linksSnowPart = useMemo(
    () => {
      const links = linksSnow(region, t);

      if (locale === ELocale.FR_FR && region.uuid === '15') {
        return links.filter((item) => item.uuid !== CurrentLink.LODGING);
      }

      return links;
    },
    [locale, region, t],
  );
  const linksPlanningPart = useMemo(
    () => linksPlan(region, t),
    [region, t],
  );

  return (
    <div>
      <HeroNav
        title={title}
        backgroundPhoto={photo}
        links={[...(linksPlanningPart || []), ...linksSnowPart]}
        link={link}
        resort={resort}
        region={region}
        related={related}
      />
    </div>
  );
};
